export function reportRecordOpeningError(message) {
    if (window.toastr) {
        window.toastr.error(message);
        return;
    }

    let alert = document.getElementById('record-opening-error');

    if (!alert) {
        alert = document.createElement('div');
        alert.id = 'record-opening-error';
        alert.className = 'alert alert-danger';
        alert.setAttribute('role', 'alert');
        Object.assign(alert.style, {
            position: 'fixed',
            top: '1rem',
            right: '1rem',
            zIndex: '11000',
            maxWidth: '28rem',
            boxShadow: '0 0.5rem 1.5rem rgba(0, 0, 0, 0.18)',
        });
        document.body.appendChild(alert);
    }

    alert.textContent = message;
}
